import { ComponentType, SVGProps, useEffect, useMemo } from 'react';
import { ParseKeys } from 'i18next';
import { useKeenSlider } from 'keen-slider/react';
import { useTranslation } from 'next-i18next';
import { cn } from '@zep/utils';
interface Award {
  id: number;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: ParseKeys<['home']>;
}
interface AwardsTickerProps {
  awards: readonly Award[];
  direction?: 'left' | 'right';
  duration?: number;
}
export const AwardsTicker = ({
  awards,
  direction = 'left',
  duration = 6000
}: AwardsTickerProps) => {
  const {
    t
  } = useTranslation(['home']);
  const memoDirection = useMemo(() => direction === 'left' ? 1 : -1, [direction]);
  const animation = useMemo(() => ({
    duration,
    easing: (t: number) => t
  }), [duration]);
  const [sliderRef, slider] = useKeenSlider({
    loop: true,
    renderMode: 'performance',
    drag: false,
    slides: {
      perView: 'auto'
    }
  });
  useEffect(() => {
    const instance = slider.current;
    if (!instance || !awards || awards.length <= 0) return;
    const animate = () => {
      instance.moveToIdx(instance.track.details.abs + memoDirection, true, animation);
    };
    instance.on('animationEnded', animate);
    instance.on('updated', animate);

    // 초기 애니메이션 시작
    animate();
    return () => {
      instance.on('animationEnded', animate, true);
      instance.on('updated', animate, true);
    };
  }, [animation, slider, awards, memoDirection]);
  return <div className="relative w-full overflow-hidden" data-sentry-component="AwardsTicker" data-sentry-source-file="AwardsTicker.tsx">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-[100px] bg-gradient-to-r from-white from-20% to-transparent" />
      <div ref={sliderRef} className="keen-slider">
        {awards.map((award, index) => <div key={`${award.id}-${index}`} className="keen-slider__slide w-auto min-w-fit">
            <div className={cn('flex items-center gap-quiz-xs tablet:gap-quiz-sm', 'py-quiz-3xs', 'opacity-80', 'px-[16px] tablet:px-[16px]', 'shrink-0')}>
              <award.icon className="size-4 shrink-0 text-quiz-gray-700 tablet:size-6" />
              <span className="whitespace-nowrap text-quiz-body-md-bold text-quiz-gray-900 tablet:text-quiz-heading-md-bold">
                {t(award.title)}
              </span>
            </div>
          </div>)}
      </div>
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-[100px] bg-gradient-to-l from-white from-20% to-transparent" />
    </div>;
};